import React from "react";
import SharedMediaGrid from "./SharedMediaGrid";

export default function ConversationMediaSection({ items, isProbablyGifUrl, onRefresh, loading }) {
  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-[13px] font-semibold text-white/90">Photos &amp; GIFs</h3>
        <button
          type="button"
          onClick={onRefresh}
          disabled={loading}
          className="text-[12px] text-[#9cc8e8] hover:text-white disabled:opacity-50"
        >
          Refresh
        </button>
      </div>
      <p className="text-[12px] text-white/45 mb-3">From links and GIFs sent in this conversation.</p>
      <SharedMediaGrid items={items} isProbablyGifUrl={isProbablyGifUrl} />
    </div>
  );
}
